import { h } from 'preact';
import Store from 'store/store';
import { Modal, toast } from 'utils/modal';
import { beforePublish, hasUnsavedChanges, publish, save, isPlaceholder } from 'utils/data';
import { joinClasses } from 'utils/utils';
import * as jsonPointer from 'utils/jsonPointer';

import Button from 'components/button/button';
import ContactLink from 'components/contactLink/contactLink';

import s from 'components/publish/publish.sss';

export default class Publish extends Modal {
	s = s;

	constructor(props) {
		super(props);

		this.cancel = this.cancel.bind(this);
		this.publish = this.publish.bind(this);
		this.saveAndPublish = this.saveAndPublish.bind(this);
	}

	get hasUnsavedChanges() {
		return hasUnsavedChanges(this.props.path);
	}

	get title() {
		if (this.hasUnsavedChanges) return 'Save changes before publishing?';
		return 'Publish';
	}

	cancel() {
		this.base.close();
	}

	async publishRaw(saveFirst) {
		this.setState({ publishing: true, error: null });
		try {
			// Run beforePublish actions
			const saveRequired = await beforePublish(this.props.path);

			if (saveFirst || saveRequired) {
				await save(this.props.path);
			}

			await publish(this.props.path);
			toast('Site published!', { icon: 'rocket' });
			this.base.close();
		} catch (err) {
			console.error(err);
			// toast('Error while publishing', {});
			this.setState({ error: { at: new Date(), error: err }, publishing: false });
		}
	}

	async publish() {
		return this.publishRaw();
	}
	async saveAndPublish() {
		return this.publishRaw(true);
	}

	renderContent() {
		const isMoviePage = this.props.path?.startsWith('/movies/');
		const lines = [];
		if (this.hasUnsavedChanges) {
			lines.push('You have unsaved changes. Would you like to save and publish them now?');
		}
		if (isMoviePage && !isPlaceholder(jsonPointer.get(Store.get().data, this.props.path))) {
			lines.push('This will publish all pending changes live across the movie pages and hubsite.');
		}

		if (!lines.length) {
			lines.push('Are you sure you want to publish?');
		}
		const error = this.state.error;
		const errorSupportLink = (
			<ContactLink
				subject="Error while publishing content"
				body={[
					`Error publishing ${this.props.path} at ${error?.at.toISOString() || Date.now()}\n`,
					`Browser: ${navigator.userAgent}\n`,
					'Error details:',
					error?.error.message,
					error?.error.stack
				].filter(e => e).join('\n') + '\n'}
			>
				contact us
			</ContactLink>
		);
		return (
			<p class={joinClasses(this.c('content'), error && s.hasError)}>
				{lines.join('\n')}
				<div class={s.error}>
					Sorry, an error occured while publishing your changes. Please try again later or {errorSupportLink} if the problem persists.
				</div>
			</p>
		);
	}

	renderActions() {
		return (
			<div class={this.c('actions')}>
				<Button type="submit" value="CANCEL" key="cancel">Cancel</Button>
				{this.hasUnsavedChanges
					? <Button primary icon="rocket" onClick={this.saveAndPublish} disabled={this.state.publishing} key="save-publish">Save and publish</Button>
					: <Button primary icon="rocket" onClick={this.publish} disabled={this.state.publishing} key="publish">Publish</Button>}
			</div>
		);
	}
}